const Menu = [
  {
    key: "routekey-home",
    label: "sidebar.dashboard",
    path: "/app/dashboard",
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-goodsin",
    label: "sidebar.goodsin",
    path: "/app/goodsin",
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-dispatchorders",
    label: "sidebar.dispatchorders",
    path: "/app/dispatchorders",
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-summaryreports",
    label: "sidebar.summaryreport",
    path: "/app/report",
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-InventoryReport",
    label: "sidebar.InventoryReport",
    path: "/app/iteminventoryreport",
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-Reconciliation",
    label: "sidebar.Reconciliation",
    path: "/app/reconciliation",
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-searchgoods",
    label: "sidebar.searchgoods",
    path: "/app/searchgoods",
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-admin",
    label: "sidebar.admin",
    path: "/app/admin",
    vissbleOnSmallScrren: true,
  },
];

export default Menu;
